import { ErrorCode, PortalApiError } from '@afterpaytouch/portal-api/types'
import { Route } from '../../config/router'
import { TrackingEvent } from '../../model/monitoring'
import { ErrorHandler, CheckoutErrorContext } from './types'

export const createCheckoutStartAURegulationErrorHandler = (): ErrorHandler => {
  const auRegErrorCodes = [ErrorCode.UnsuitabilityNotFound, ErrorCode.UnsuitabilityExpired, ErrorCode.ContractAcceptanceRequired]

  return {
    canHandle: (errorCode: ErrorCode, error: PortalApiError): boolean => {
      return auRegErrorCodes.includes(errorCode)
    },

    handle: async (errorCode: ErrorCode, error: PortalApiError, context: CheckoutErrorContext): Promise<Route | undefined> => {
      context.logEvent(TrackingEvent.CHECKOUT_DECLINED, {
        isRecoverableTerminalError: false,
        errorCode,
      })

      if (errorCode === ErrorCode.UnsuitabilityNotFound || errorCode === ErrorCode.UnsuitabilityExpired) {
        return Route.UNSUITABILITY_QUESTION_FORM
      } else if (errorCode === ErrorCode.ContractAcceptanceRequired) {
        return Route.CONTRACT_AGREEMENT
      }

      return undefined
    },
  }
}
